import { ViewModel, View, ObservableArray } from "binder"
import { ProductionStopListManipulationView } from "./productionStopListManipulation-view"
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { PaginationInfo, ServerSideDataLoader, TimeSelectorViewModel } from "uicomponents";
import { ServerConnection } from "src/server/serverConnection";
import { ProductionStopListEditorViewModel, ProductionStopListInserter, ProductionStopListUpdater } from "./productionStopListEditor/productionStopListEditor-viewModel";
import { IProductionStopList } from "./IProductionStopList";
import { ProductLineSelectorViewModel } from "./Selectors/productLineSelector-viewModel";
import { StopReasonSelectorViewModel } from "./Selectors/stopReasonSelector-viewModel";
import { WorkStationSelectorViewModel } from "./Selectors/workStationSelector-viewModel";
import moment from "moment";
import { TimePart } from "src/uicomponents/components/timeSelector/timeSelector-viewModel";

export class ProductionStopListManipulationViewModel extends WindowViewModel {
    public getTitle(): string {
        return 'تعریف توقفات';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);

        this.isLoading = false;
        this.productionStopLists = ObservableArray.create<ProductionStopList>();
        this.dataLoader = new ServerSideDataLoader(filteringInformation => this.refreshPaged(filteringInformation), 30);

        this.refresh();
    }
    GetDefaultView(): View<ViewModel> {
        return new ProductionStopListManipulationView();
    }
    public getTypeId(): string {
        return "VM-62B3B255-8833-4068-B58D-40655370DD18"
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set productionStopLists(v: ObservableArray<ProductionStopList>) { this._productionStopLists = v; } public get productionStopLists(): ObservableArray<ProductionStopList> { return this._productionStopLists; } private _productionStopLists: ObservableArray<ProductionStopList>;
    public set dataLoader(v: ServerSideDataLoader) { this._dataLoader = v; } public get dataLoader(): ServerSideDataLoader { return this._dataLoader; } private _dataLoader: ServerSideDataLoader;

    async refresh() {
        await this.dataLoader.refresh();
    }

    async refreshPaged(filteringInformation: any): Promise<PaginationInfo> {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/ProductionStopServices/ListAllProductionStops', {
                FilteringInformation: filteringInformation
            });
            this.productionStopLists.update(...result.ProductionStops.map((x, i) => {
                let p = new ProductionStopList(this);
                p.index = ((result.PaginationInfo.CurrentPage - 1) * result.PaginationInfo.PageSize) + i + 1;
                p.id = x.Id;
                p.date = x.From;
                p.productLineName = x.ProductLineName;
                p.workStationName = x.WorkStationName;
                p.stopReasonName = x.StopReasonName;
                p.personnelName = x.PersonnelName;
                p.timeSelector=new TimeSelectorViewModel(this);
                const m = new TimePart(this);
                m.no = moment.utc(x.From).minute();
                const h = new TimePart(this);
                h.no = moment.utc(x.From).hour();
                p.timeSelector.selectedMinute = m;
                p.timeSelector.selectedHour = h;
                return p;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage, result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0, 0);
        } finally {
            this.isLoading = false;
        }
    }

    async addNew() {
        let popup = new ProductionStopListEditorViewModel(this, new ProductionStopListInserter());
        let result = await this.showPopup(popup);
        if (result == 'done') {
            this.dataLoader.refresh();
        }
    }

    async edit(productionStopList: IProductionStopList) {
        let popup = new ProductionStopListEditorViewModel(this, new ProductionStopListUpdater());
        await productionStopList.cloneTo(popup);
        let result = await this.requestShowingPopup(popup);
        if (result == 'done') {
            this.dataLoader.refresh();
        }
    }

    async remove(productionStopList: ProductionStopList): Promise<void> {
        let isDeleted = await this.messageBoxDangerYesNo('آیا از حذف اطمینان دارید؟', 'حذف');
        if (isDeleted == 'yes') {
            try {
                this.isLoading = true;
                let result = await ServerConnection.callServer("/Complex/ProductionStopServices/DeleteProductionStop", {
                    ProductionStopId: productionStopList.id,
                });
                if (result.IsSuccessful == true) {
                    await this.messageBoxConfirmSuccess("حذف با موفقیت انجام شد", "عملیات موفق");
                    this.dataLoader.refresh();
                }
            } catch (ex) {
                await this.messageBoxConfirmWarning("خطا در عملیات حذف", "خطا در عملیات");
                console.log(ex);
            } finally {
                this.isLoading = false;
            }
        }
    }
}

export class ProductionStopList extends ViewModel implements IProductionStopList {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ProductionStopListManipulationViewModel) {
        super(parent);
        this._typedParent = parent;

        this.timeSelector = new TimeSelectorViewModel(this);
    }

    private _typedParent: ProductionStopListManipulationViewModel;
    public set index(v: number) { this._index = v; } public get index(): number { return this._index; } private _index: number;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set date(v: moment.Moment) { this._date = v; } public get date(): moment.Moment { return this._date; } private _date: moment.Moment;
    public set time(v: string) { this._time = v; } public get time(): string { return this._time; } private _time: string;
    public set productLineId(v: string) { this._productLineId = v; } public get productLineId(): string { return this._productLineId; } private _productLineId: string;
    public set productLineName(v: string) { this._productLineName = v; } public get productLineName(): string { return this._productLineName; } private _productLineName: string;
    public set productLineSelector(v: ProductLineSelectorViewModel) { this._productLineSelector = v; } public get productLineSelector(): ProductLineSelectorViewModel { return this._productLineSelector; } private _productLineSelector: ProductLineSelectorViewModel;
    public set workStationId(v: string) { this._workStationId = v; } public get workStationId(): string { return this._workStationId; } private _workStationId: string;
    public set workStationName(v: string) { this._workStationName = v; } public get workStationName(): string { return this._workStationName; } private _workStationName: string;
    public set workStationSelector(v: WorkStationSelectorViewModel) { this._workStationSelector = v; } public get workStationSelector(): WorkStationSelectorViewModel { return this._workStationSelector; } private _workStationSelector: WorkStationSelectorViewModel;
    public set stopReasonId(v: string) { this._stopReasonId = v; } public get stopReasonId(): string { return this._stopReasonId; } private _stopReasonId: string;
    public set stopReasonName(v: string) { this._stopReasonName = v; } public get stopReasonName(): string { return this._stopReasonName; } private _stopReasonName: string;
    public set stopReasonSelector(v: StopReasonSelectorViewModel) { this._stopReasonSelector = v; } public get stopReasonSelector(): StopReasonSelectorViewModel { return this._stopReasonSelector; } private _stopReasonSelector: StopReasonSelectorViewModel;
    public set personnelName(v: string) { this._personnelName = v; } public get personnelName(): string { return this._personnelName; } private _personnelName: string;
    public set timeSelector(v: TimeSelectorViewModel) { this._timeSelector = v; } public get timeSelector(): TimeSelectorViewModel { return this._timeSelector; } private _timeSelector: TimeSelectorViewModel;

    setProductLineId(id: string) {
        this.productLineId = id;
    }
    getProductLineId(): string {
        return this.productLineId;
    }

    setWorkStationId(id: string) {
        this.workStationId = id;
    }
    getWorkStationId(): string {
        return this.workStationId;
    }

    setStopReasonId(id: string) {
        this.stopReasonId = id;
    }
    getStopReasonId(): string {
        return this.stopReasonId;
    }

    async cloneTo(productionStopList: IProductionStopList) {
        productionStopList.id = this.id;
        productionStopList.date = this.date;
        productionStopList.time = this.time;
        productionStopList.productLineName = this.productLineName;
        productionStopList.workStationName = this.workStationName;
        productionStopList.stopReasonName = this.stopReasonName;
        productionStopList.personnelName = this.personnelName;
        productionStopList.setProductLineId(this.productLineId);
        productionStopList.setWorkStationId(this.workStationId);
        productionStopList.setStopReasonId(this.stopReasonId);
    }

    async edit() {
        this._typedParent.edit(this);
    }

    async remove(): Promise<void> {
        this._typedParent.remove(this);
    }
}
